import React, { useState } from 'react';
import {
  Box,
} from "@mui/material";
import styles from "../../entity-editor/EntityEditor.styles";
import StyledTextField from "../../styled-components/StyledTextField";
import ValidatedAccordion from './ValidatedAccordion';

const ObjectPlotBlock = ({ onChange, objectFields, errors }) => {
  const [expanded, setExpanded] = useState<null | "plot">(null);

  return (
    <ValidatedAccordion
      title="Plot *"
      hasErrors={!errors.isFilledCityCode || !errors.isFilledPlotNumber || !errors.isFilledSection || !errors.isFilledPlotIndex}
      expanded={expanded === "plot"}
      onChange={(isExp) => setExpanded(isExp ? "plot" : null)}
    >
        <Box sx={styles.fieldHolder}>
          <Box sx={styles.fieldBlock}>
            <StyledTextField
              fullWidth
              required
              label="City code"
              margin="dense"
              onChange={(e) => onChange("objectPlot", "city_code", e, -1)}
              value={objectFields?.city_code || ""}
              error={!errors.isFilledCityCode}
            />
            <StyledTextField
              fullWidth
              required
              label="Section"
              margin="dense"
              onChange={(e) => onChange("objectPlot", "section", e, -1)}
              value={objectFields?.section || ""}
              error={!errors.isFilledSection}
            />
          </Box>
          <Box sx={styles.fieldBlock}>
            <StyledTextField
              fullWidth
              required
              label="Plot number"
              margin="dense"
              onChange={(e) => onChange("objectPlot", "plot_number", e, -1)}
              value={objectFields?.plot_number || ""}
              error={!errors.isFilledPlotNumber}
            />
            <StyledTextField
              fullWidth
              required
              label="Index"
              margin="dense"
              onChange={(e) => onChange("objectPlot", "index", e, -1)}
              value={objectFields?.index || ""}
              error={!errors.isFilledPlotIndex}
            />
          </Box>
        </Box>
    </ValidatedAccordion>
  );
};

export default ObjectPlotBlock;
